import {
  PARTICULARS_MOBILE_OPERATOR_ERROR,
  PARTICULARS_MOBILE_OPERATOR_REQUEST,
  PARTICULARS_MOBILE_OPERATOR_SUCCESS,
  CHECK_NUMBER_PORT_REQUEST,
  CHECK_NUMBER_PORT_SUCCESS,
  CHECK_NUMBER_PORT_ERROR,
  RESET_NUMBER_PORT
} from '@/actions/numberPort/actionTypes';


export const initialState = {
  mobileOperators: [],
  isLoading: false,
  subscriberDetails: {
    firstName: '',
    lastName: '',
    mobileNo: '',
    email: '',
    brn: '',
    portInDate: '',
    companyName: '',
    mobileOperatorName: '',
    documents: []
  },
  numberPortEligibilityData: {},
  numberPortEligibilityLoading: false,
  numberPortEligibilityError: '',
  mobileOperatorsLoading: false
};

const numberPortReducers = (state = initialState, action) => {
  switch (action.type) {
    case PARTICULARS_MOBILE_OPERATOR_REQUEST:
      return {
        ...state,
        mobileOperatorsLoading: true
      };
    case PARTICULARS_MOBILE_OPERATOR_SUCCESS:
      return {
        ...state,
        mobileOperators: action.data,
        mobileOperatorsLoading: false
      };
    case PARTICULARS_MOBILE_OPERATOR_ERROR:
      return {
        ...state,
        mobileOperators: [],
        mobileOperatorsLoading: false
      };

    case CHECK_NUMBER_PORT_REQUEST:
      return {
        ...state,
        numberPortEligibilityLoading: true,
        numberPortEligibilityData: {},
        numberPortEligibilityError: ''
      };
    case CHECK_NUMBER_PORT_SUCCESS:
      return {
        ...state,
        subscriberDetails: action.data.subscriberDetails,
        numberPortEligibilityLoading: false,
        numberPortEligibilityData: action.data.eligibilityData,
        numberPortEligibilityError: ''
      };
    case CHECK_NUMBER_PORT_ERROR:
      return {
        ...state,
        numberPortEligibilityLoading: false,
        numberPortEligibilityData: {},
        numberPortEligibilityError: action.error.response?.data?.message
      };

    case RESET_NUMBER_PORT:
      return initialState

    default:
      return state;
  }
};

export default numberPortReducers;
